import React, { useState } from 'react';

const Composition = ({ sectionData }) => {
  // State for the modal
  const [modalData, setModalData] = useState(null);

  // Helper function to assign icons based on the Role Name dynamically
  const getIcon = (heading) => {
    const lower = heading.toLowerCase();
    if (lower.includes('chairperson') || lower.includes('secretary')) return null; // These usually don't have icons in your design
    if (lower.includes('scientist')) return "fa-flask";
    if (lower.includes('clinician')) return "fa-user-md";
    if (lower.includes('philosopher')) return "fa-book";
    if (lower.includes('layperson')) return "fa-users";
    return "fa-user"; // Default icon
  };

  // Helper to open modal
  const openModal = (title, contentList) => {
    setModalData({ title, contentList });
  };

  // Helper to close modal
  const closeModal = () => {
    setModalData(null);
  };

  // If data hasn't loaded yet
  if (!sectionData || sectionData.length === 0) return null;

  return (
    <section className="composition-section">
      <div className="container">
        
        {/* Loop through the main sections (e.g., Composition, Members) */}
        {sectionData.map((section) => (
          <div key={section.id} className="mb-2 mb-md-5">
            
            {/* Section Heading */}
            <div className="sec-title text-center">
              <h2>{section.main_heading.replace(':', '')}</h2>
            </div>

            {/* Extra Intro Text (if available) */}
            {section.extra_input && (
              <div className="row d-flex justify-content-center align-items-center mb-4">
                <p className="text-start">{section.extra_input}</p>
              </div>
            )}

            <div className="row d-flex justify-content-center gap-3 gap-md-0">
              {/* The API returns 'tabs' as an Object with timestamp keys.
                  We use Object.entries to convert it to an array for mapping.
              */}
              {Object.entries(section.tabs).map(([key, tab]) => {
                const headingText = tab.heading.replace(':', '').trim();
                const iconClass = getIcon(headingText);
                
                // Logic for "View More": Show only first 3 items initially
                const maxItems = 3;
                const showViewMore = tab.content.length > maxItems;
                const displayContent = showViewMore ? tab.content.slice(0, maxItems) : tab.content;
                
                // Special styling for Chairperson/Secretary (Centered text)
                const isHeaderRole = headingText.toLowerCase().includes('chairperson') || headingText.toLowerCase().includes('secretary');

                return (
                  <div key={key} className="col-md-6 col-12 mb-4">
                    <div className="member-card h-100">
                      
                      {/* Role Title */}
                      <div className={`member-role ${isHeaderRole ? 'text-center' : ''}`}>
                        {iconClass && <i className={`fa ${iconClass} me-2`}></i>}
                        {isHeaderRole ? (
                           <h2 className="text-white d-inline-block">{headingText}</h2>
                        ) : (
                           headingText
                        )}
                      </div>

                      {/* List of People */}
                      <ul className="member-list mt-3">
                        {displayContent.map((htmlString, index) => (
                          // using dangerouslySetInnerHTML because API returns raw HTML from Summernote
                          <li key={index} dangerouslySetInnerHTML={{ __html: htmlString }}></li>
                        ))}
                      </ul>

                      {/* Dynamic View More Button */}
                      {showViewMore && (
                        <div className="text-center mt-auto pb-3">
                          <button 
                            className="readmoreall" 
                            onClick={() => openModal(headingText, tab.content)}
                          >
                            View More
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}

        {/* Dynamic Modal */}
        {modalData && (
          <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-scrollable modal-lg">
              <div className="modal-content">
                
                <div className="modal-header">
                  <h5 className="modal-title">
                    <i className={`fa ${getIcon(modalData.title) || 'fa-user'} me-2`}></i>
                    {modalData.title}
                  </h5>
                  <button
                      type="button"
                      className="btn text-dark p-0 border-0 bg-transparent"
                      style={{fontSize: '1.5rem'}}
                      onClick={closeModal}
                    >
                      <i className="fa fa-times"></i>
                    </button>
                </div>

                <div className="modal-body">
                  <div className="member-card border-0 shadow-none">
                    <ul className="member-list">
                      {modalData.contentList.map((htmlString, index) => (
                         <li key={index} dangerouslySetInnerHTML={{ __html: htmlString }}></li>
                      ))}
                    </ul>
                  </div>
                </div>

              </div>
            </div>
          </div>
        )}

      </div>
    </section>
  );
};

export default Composition;